(() => {
  const overViewPage = document.querySelector(".overview-page-block");
  
  if(!overViewPage) return
  
  const overViewSearchEl = document.querySelector(".overview-search");
  const overViewPageCountries = Array.from(document.querySelectorAll('.dc-individual-countries'));
  
  if(!overViewSearchEl || !overViewPageCountries || overViewPageCountries.length === 0) return;
  
  try {
    overViewSearchEl.addEventListener('input', (e) => {
      const value = e.target.value
        overViewPageCountries.forEach((el) => {
          !value || el.innerText.toUpperCase().includes(value.toUpperCase()) 
            ? toggleClass(el, "d-none", "d-block")
            : toggleClass(el, "d-block", "d-none")
        });
    })
  } catch(e) {
    console.error(e)
    console.error("error in overview search")
  }
})()